import { Heading, Stack, Text } from 'braid-design-system';
import React from 'react';

import { StaticPageProvider, TextLink } from 'src/components';

import { ErrorWrapper } from '../components/ErrorWrapper/ErrorWrapper';

const StaticPageProps = {
  title: 'Recruiter Network',
  returnUrl: '/',
  currentPage: 'recruiter-network-closure',
  eventName: 'recruiter-network-closure-page-viewed',
  hideHeader: true,
  hideFooter: true,
};

const RecruiterNetworkClosure = () => (
  <StaticPageProvider {...StaticPageProps}>
    <ErrorWrapper image="Announce">
      <Stack space="gutter" align="center">
        <Heading level="3">
          SEEK Recruiter Network is no longer available
        </Heading>
        <Stack space="large">
          <Stack space="xsmall">
            <Text tone="secondary" align="center">
              We&apos;ve made the hard decision to close SEEK Recruiter Network.
            </Text>
            <Text tone="secondary" align="center">
              If you have an active brief with us, you&apos;ll continue to be
              supported.
            </Text>
          </Stack>
          <Text tone="secondary" align="center">
            Need help? Reach out to us at{' '}
            <TextLink
              href="mailto:recruiternetwork@seek.com.au"
              tracking="recruiter-network-email-link-clicked"
            >
              recruiternetwork@seek.com.au
            </TextLink>
          </Text>
        </Stack>
      </Stack>
    </ErrorWrapper>
  </StaticPageProvider>
);

export default RecruiterNetworkClosure;
